export const basicAuth = {
    username: "Rajneesh@example.com",
    password: "Test@12345",
  };
  
  
  
  export const billpunchbasicauth={
    username: "abhijeet@bumppy",
    password: "password",
  
  }
  export const basicauthblog={
    username: "BUMPPY_SSO_SgLjvARJ5LbX",
    password: "tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq",
  
  }